import { TYPES } from "./payout_setting.type";

const INITIAL_STATE = {
  holidays: {},
  loading: false,
  afterHours: null,
  afterHoursLoading: false,
  general: null,
  generalLoading: false,
};

const payoutSettingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.GET_HOLIDAYS_REQUEST:
      return { ...state, loading: true };
    case TYPES.GET_HOLIDAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        holidays: { ...state.holidays, [action.payload.year]: action.payload.data },
      };
    case TYPES.SAVE_HOLIDAYS_SUCCESS:
      return {
        ...state,
        holidays: { ...state.holidays, [action.payload.year]: action.payload.holidays },
      };
    case TYPES.GET_AFTER_HOURS_REQUEST:
      return { ...state, afterHoursLoading: true };
    case TYPES.GET_AFTER_HOURS_SUCCESS:
      return { ...state, afterHoursLoading: false, afterHours: action.payload };
    case TYPES.SAVE_AFTER_HOURS_SUCCESS:
      return { ...state, afterHours: action.payload };
    case TYPES.GET_GENERAL_REQUEST:
      return { ...state, generalLoading: true };
    case TYPES.GET_GENERAL_SUCCESS:
      return { ...state, generalLoading: false, general: action.payload };
    case TYPES.SAVE_GENERAL_SUCCESS:
      return { ...state, general: action.payload };
    default:
      return state;
  }
};

export default payoutSettingReducer;
